module.exports = __webpack_public_path__ + "static/media/add_icon.ca3b9ce9.svg";